import { quickFetchOrGet } from '../../utils/ajaxUtils';
import { BASE_URI_LC } from '../../constants/ApiConstants';
import { dataFetchingClient, registerQuery, useQuery } from '../../utils/DataFetchingClient';
const GET_FILTERS = registerQuery({
  fieldName: 'filters',
  args: [],

  fetcher() {
    return quickFetchOrGet('academy-filters', `${BASE_URI_LC}/filters`);
  }

});
export const getFilters = () => {
  return dataFetchingClient.queryUnwrapped({
    query: GET_FILTERS
  });
};
export const useFilters = () => {
  const {
    data: filters,
    loading: filtersLoading,
    error: filtersError
  } = useQuery(GET_FILTERS);
  return {
    filters,
    filtersLoading,
    filtersError
  };
};